import { useState } from 'react';
import EditIcon from '@material-ui/icons/Edit';
import Check from '@material-ui/icons/Check';
import Cross from '@material-ui/icons/Clear';
import API from '../../../create/api';

export default function MobileTableRowAddress({ row, refreshData }: any) {
  // Add this state variable at the start of your component
  const [isEditing, setIsEditing] = useState(false);
  const [address, setAddress] = useState(row?.address ?? '');

  function updateAddress() {
    return API.update(`${process.env.REACT_APP_API_SERVER}/parcels`, row?.id, { address }).finally(() => {
      refreshData();
      setIsEditing(false);
    });
  }

  return (
    <div className="">
      <span className="text-gray-500">Address: </span>
      {isEditing ? (
        <>
          <input type="text" className="p-1 rounded-md" value={address} onChange={(e) => setAddress(e.target.value)} />{' '}
          <Check className="bg-green-300 text-white hover:cursor-pointer" onClick={() => updateAddress()} />{' '}
          <Cross
            className="bg-red-400 text-white hover:cursor-pointer"
            onClick={() => {
              setIsEditing(false);
            }}
          />
        </>
      ) : (
        <>
          {row?.address ?? ''}
          <button
            onClick={() => {
              setIsEditing(true);
            }}
          >
            <EditIcon style={{ fontSize: '0.8rem' }} />
          </button>
        </>
      )}

      {row?.area?.name ? <p> [Area: {row?.area?.name}] </p> : ''}
    </div>
  );
}
